import { Component, inject } from '@angular/core';
import { BaseClientTaskHistoryComponent } from '../base-client-task-history/base-client-task-history.component';
import { ClientConsultNoteTasksService } from 'app/core/services/client-consult-note-tasks.service';

import { ClientTaskNavComponent } from '../../components/client-task-nav/client-task-nav.component';
import { ClientTaskHistoryItemListComponent } from '../../components/client-task-history-item-list/client-task-history-item-list.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-client-consult-note-task-history',
  templateUrl: './client-consult-note-task-history.component.html',
  styleUrls: ['./client-consult-note-task-history.component.scss'],
  imports: [ClientTaskNavComponent, ClientTaskHistoryItemListComponent, MatProgressSpinner]
})
export class ClientConsultNoteTaskHistoryComponent extends BaseClientTaskHistoryComponent {
  constructor() {
    const clientTasksService = inject(ClientConsultNoteTasksService);

    super(clientTasksService);
  }
}
